// import $ from "jquery";

// import script accordingly
import "./themes/utils/_autoload";
import "./themes/elementor-widget/_autoload";
import "./themes/vendor/_autoload";
